export default __webpack_public_path__ + "static/bckPackages-d113d0b676368547cfab8f4796176b1d.jpg";